import { ApolloClient } from '@apollo/client';
import logger from '../common/helpers/logger/logger';
import {
  RECOMMENDED_LOCATION_QUERY,
  RecommendedLocation,
  RecommendedLocationQueryResponse,
} from '../queries/homePage/locationRecommendation';
import {
  LocationInfo,
  LocationQueryRequest,
  LocationQueryResponse,
  LOCATION_QUERY,
} from '../queries/searchPage/location';

export async function fetchRecommendedLocations(
  client: ApolloClient<unknown>,
): Promise<RecommendedLocation[]> {
  try {
    logger.logInfo('locationService.fetchRecommendedLocations', 'Begin');

    const response = await client.query<RecommendedLocationQueryResponse>({
      query: RECOMMENDED_LOCATION_QUERY,
    });

    return response.data.recommendedLocations.items ?? [];
  } catch (error) {
    logger.logError(
      'locationService.fetchRecommendedLocations',
      'Error retrieving from query.',
      error,
    );
    throw error;
  }
}

interface FetchLocationOptions {
  locationType?: string;
  locationSlug?: string;
}
export async function fetchLocation(
  client: ApolloClient<unknown>,
  options: FetchLocationOptions,
): Promise<LocationInfo> {
  try {
    logger.logInfo('locationService.fetchLocation', 'Begin');

    const response = await client.query<
      LocationQueryResponse,
      LocationQueryRequest
    >({
      query: LOCATION_QUERY,
      variables: {
        type: options.locationType,
        slug: options.locationSlug,
      },
    });

    return response?.data?.locationInfo;
  } catch (error) {
    logger.logError(
      'locationService.fetchLocation',
      'Error retrieving from query.',
      error,
    );
    throw error;
  }
}
